import Container from '@mui/material/Container';
import { PAGES_ANALYTICS_TITLES } from '../../utils/enums';
import { PageHelmet } from '../../components';
import { Pricing } from '../../components/Pricing';

const PricingPage = () => (
  <PageHelmet title={PAGES_ANALYTICS_TITLES.PRICING}>
    <Container
      sx={{
        px: { xs: 1, lg: 2 },
      }}
      maxWidth={false}
    >
      <Pricing />
    </Container>
  </PageHelmet>
);

export default PricingPage;
